// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   shippingAddress: JSON.parse(localStorage.getItem("shippingAddress")) || null,
//   billingAddress: JSON.parse(localStorage.getItem("billingAddress")) || null,
//   savedAddresses: JSON.parse(localStorage.getItem("savedAddresses")) || [],
//   useSameAsShipping: true,
// };

// const addressSlice = createSlice({
//   name: "address",
//   initialState,
//   reducers: {
//     // Set the shipping address
//     setShippingAddress: (state, action) => {
//       state.shippingAddress = action.payload;
//       localStorage.setItem("shippingAddress", JSON.stringify(action.payload));
//     },

//     // Set the billing address
//     setBillingAddress: (state, action) => {
//       state.billingAddress = action.payload;
//       localStorage.setItem("billingAddress", JSON.stringify(action.payload));
//     },

//     // Add a new saved address (without affecting shipping address)
//     addSavedAddress: (state, action) => {
//       state.savedAddresses.push(action.payload);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },
//     // Add to your addressSlice
// removeSavedAddress: (state, action) => {
//   const index = action.payload;
//   state.savedAddresses.splice(index, 1);
//   localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
// },


//     // Toggle billing address same as shipping
//     toggleUseSameAsShipping: (state) => {
//       state.useSameAsShipping = !state.useSameAsShipping;
//     },

//     // Clear Addresses
//     clearAddresses: (state) => {
//       state.shippingAddress = null;
//       state.billingAddress = null;
//       state.savedAddresses = [];
//       localStorage.removeItem("shippingAddress");
//       localStorage.removeItem("billingAddress");
//       localStorage.removeItem("savedAddresses");
//     },
//   },
// });

// // Export actions
// export const {
//   setShippingAddress,
//   setBillingAddress,
//   toggleUseSameAsShipping,
//   addSavedAddress, removeSavedAddress,// Exporting new action
//   clearAddresses,
// } = addressSlice.actions;

// // Export reducer
// export default addressSlice.reducer;


// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   shippingAddress: JSON.parse(localStorage.getItem("shippingAddress")) || null,
//   billingAddress: JSON.parse(localStorage.getItem("billingAddress")) || null,
//   savedAddresses: JSON.parse(localStorage.getItem("savedAddresses")) || [],
//   useSameAsShipping: true,
// };

// const addressSlice = createSlice({
//   name: "address",
//   initialState,
//   reducers: {
//     // Set the shipping address
//     setShippingAddress: (state, action) => {
//       state.shippingAddress = action.payload;
//       localStorage.setItem("shippingAddress", JSON.stringify(action.payload));
//     },

//     // Set the billing address
//     setBillingAddress: (state, action) => {
//       state.billingAddress = action.payload;
//       localStorage.setItem("billingAddress", JSON.stringify(action.payload));
//     },

//     // Add a new saved address (without affecting shipping address)
//     addSavedAddress: (state, action) => {
//       state.savedAddresses.push(action.payload);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },

//     // Remove a saved address
//     removeSavedAddress: (state, action) => {
//       const index = action.payload;
//       state.savedAddresses.splice(index, 1);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },

//     // Toggle billing address same as shipping
//     toggleUseSameAsShipping: (state) => {
//       state.useSameAsShipping = !state.useSameAsShipping;
//     },

//     // Clear Addresses
//     clearAddresses: (state) => {
//       state.shippingAddress = null;
//       state.billingAddress = null;
//       state.savedAddresses = [];
//       localStorage.removeItem("shippingAddress");
//       localStorage.removeItem("billingAddress");
//       localStorage.removeItem("savedAddresses");
//     },

//     // Remove All Addresses and Set Default
// // Remove All Addresses and Set Empty Fields
// removeAllAddresses: (state) => {
//   state.shippingAddress = null;  // Set shipping address to null (empty)
//   state.billingAddress = null;   // Set billing address to null (empty)
//   state.savedAddresses = [];     // Clear saved addresses
//   localStorage.setItem("shippingAddress", JSON.stringify(state.shippingAddress));
//   localStorage.removeItem("billingAddress");
//   localStorage.removeItem("savedAddresses");
// },

//   },
// });

// // Export actions
// export const {
//   setShippingAddress,
//   setBillingAddress,
//   toggleUseSameAsShipping,
//   addSavedAddress,
//   removeSavedAddress,
//   clearAddresses,
//   removeAllAddresses,  // Exporting new action
// } = addressSlice.actions;

// // Export reducer
// export default addressSlice.reducer;


// import { createSlice } from "@reduxjs/toolkit";

// // Initial state with loading addresses from localStorage
// const initialState = {
//   shippingAddress: JSON.parse(localStorage.getItem("shippingAddress")) || null,
//   billingAddress: JSON.parse(localStorage.getItem("billingAddress")) || null,
//   savedAddresses: JSON.parse(localStorage.getItem("savedAddresses")) || [],
//   useSameAsShipping: true,
// };

// const addressSlice = createSlice({
//   name: "address",
//   initialState,
//   reducers: {
//     // Set the shipping address
//     setShippingAddress: (state, action) => {
//       state.shippingAddress = action.payload;
//       localStorage.setItem("shippingAddress", JSON.stringify(action.payload));
//     },

//     // Set the billing address
//     setBillingAddress: (state, action) => {
//       state.billingAddress = action.payload;
//       localStorage.setItem("billingAddress", JSON.stringify(action.payload));
//     },

//     // Add a new saved address (without affecting shipping address)
//     addSavedAddress: (state, action) => {
//       state.savedAddresses.push(action.payload);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },

//     // Remove a saved address
//     removeSavedAddress: (state, action) => {
//       const index = action.payload;
//       state.savedAddresses.splice(index, 1);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },

//     // Toggle billing address same as shipping
//     toggleUseSameAsShipping: (state) => {
//       state.useSameAsShipping = !state.useSameAsShipping;
//     },

//     // Clear Addresses
//     clearAddresses: (state) => {
//       state.shippingAddress = null;
//       state.billingAddress = null;
//       state.savedAddresses = [];
//       localStorage.removeItem("shippingAddress");
//       localStorage.removeItem("billingAddress");
//       localStorage.removeItem("savedAddresses");
//     },

//     // Remove All Addresses and Set Default
//     removeAllAddresses: (state) => {
//       state.shippingAddress = null;  // Set shipping address to null (empty)
//       state.billingAddress = null;   // Set billing address to null (empty)
//       state.savedAddresses = [];     // Clear saved addresses
//       localStorage.setItem("shippingAddress", JSON.stringify(state.shippingAddress)); // Store null shipping address
//       localStorage.removeItem("billingAddress");  // Remove billing address from localStorage
//       localStorage.removeItem("savedAddresses");  // Remove saved addresses from localStorage
//     },
//   },
// });

// // Export actions
// export const {
//   setShippingAddress,
//   setBillingAddress,
//   toggleUseSameAsShipping,
//   addSavedAddress,
//   removeSavedAddress,
//   clearAddresses,
//   removeAllAddresses,  // Exporting new action
// } = addressSlice.actions;

// // Export reducer
// export default addressSlice.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/auth/user`;

// // ** Helper function to get token **
// const getAuthToken = () => {
//   return localStorage.getItem("authToken"); // Ensure the token is stored in localStorage after login
// };

// // **Thunks for API Calls**
// export const fetchAddresses = createAsyncThunk(
//   "address/fetchAddresses",
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       const response = await axios.get(`${API_BASE_URL}/get-allUserAddresses`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       return response.data.addresses;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Failed to fetch addresses");
//     }
//   }
// );

// export const addNewAddress = createAsyncThunk(
//   "address/addNewAddress",
//   async (addressData, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       const response = await axios.post(`${API_BASE_URL}/add-address`, addressData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       return response.data.address;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Failed to add address");
//     }
//   }
// );

// export const updateExistingAddress = createAsyncThunk(
//   "address/updateExistingAddress",
//   async ({ id, updatedAddress }, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       const response = await axios.put(`${API_BASE_URL}/update-address/${id}`, updatedAddress, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Failed to update address");
//     }
//   }
// );

// // **Initial State with localStorage support**
// const initialState = {
//   shippingAddress: JSON.parse(localStorage.getItem("shippingAddress")) || null,
//   billingAddress: JSON.parse(localStorage.getItem("billingAddress")) || null,
//   savedAddresses: JSON.parse(localStorage.getItem("savedAddresses")) || [],
//   useSameAsShipping: true,
//   loading: false,
//   error: null,
// };

// // **Address Slice**
// const addressSlice = createSlice({
//   name: "address",
//   initialState,
//   reducers: {
//     // **Set Shipping Address**
//     setShippingAddress: (state, action) => {
//       state.shippingAddress = action.payload;
//       localStorage.setItem("shippingAddress", JSON.stringify(action.payload));
//     },

//     // **Set Billing Address**
//     setBillingAddress: (state, action) => {
//       state.billingAddress = action.payload;
//       localStorage.setItem("billingAddress", JSON.stringify(action.payload));
//     },

//     // **Toggle billing address same as shipping**
//     toggleUseSameAsShipping: (state) => {
//       state.useSameAsShipping = !state.useSameAsShipping;
//     },

//     // **Add a saved address**
//     addSavedAddress: (state, action) => {
//       state.savedAddresses.push(action.payload);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },

//     // **Remove a saved address**
//     removeSavedAddress: (state, action) => {
//       state.savedAddresses = state.savedAddresses.filter((_, index) => index !== action.payload);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },

//     // **Clear all addresses**
//     clearAddresses: (state) => {
//       state.shippingAddress = null;
//       state.billingAddress = null;
//       state.savedAddresses = [];
//       localStorage.removeItem("shippingAddress");
//       localStorage.removeItem("billingAddress");
//       localStorage.removeItem("savedAddresses");
//     },

//     // **Remove all addresses and set default**
//     removeAllAddresses: (state) => {
//       state.shippingAddress = null;
//       state.billingAddress = null;
//       state.savedAddresses = [];
//       localStorage.setItem("shippingAddress", JSON.stringify(null));
//       localStorage.removeItem("billingAddress");
//       localStorage.removeItem("savedAddresses");
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAddresses.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(fetchAddresses.fulfilled, (state, action) => {
//         state.loading = false;
//         state.savedAddresses = action.payload;
//         localStorage.setItem("savedAddresses", JSON.stringify(action.payload));
//       })
//       .addCase(fetchAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload?.message || "Failed to fetch addresses";
//       })
//       .addCase(addNewAddress.fulfilled, (state, action) => {
//         state.savedAddresses.push(action.payload);
//         localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//       })
//       .addCase(addNewAddress.rejected, (state, action) => {
//         state.error = action.payload?.message || "Failed to add address";
//       })
//       .addCase(updateExistingAddress.fulfilled, (state, action) => {
//         state.savedAddresses = state.savedAddresses.map((address) =>
//           address._id === action.payload._id ? action.payload : address
//         );
//         localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//       })
//       .addCase(updateExistingAddress.rejected, (state, action) => {
//         state.error = action.payload?.message || "Failed to update address";
//       });
//   },
// });

// // **Export Actions**
// export const {
//   setShippingAddress,
//   setBillingAddress,
//   toggleUseSameAsShipping,
//   addSavedAddress,
//   removeSavedAddress,
//   clearAddresses,
//   removeAllAddresses,
// } = addressSlice.actions;

// // **Export Reducer**
// export default addressSlice.reducer;


// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/auth/user`;

// // ** Helper function to get token **
// const getAuthToken = () => {
//   const token = localStorage.getItem("authToken");
//   return token ? `Bearer ${token}` : null;
// };

// // ** Fetch All Addresses **
// export const fetchAddresses = createAsyncThunk(
//   "address/fetchAddresses",
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) return rejectWithValue("Authentication token missing.");

//       const response = await axios.get(`${API_BASE_URL}/get-allUserAddresses`, {
//         headers: { Authorization: token },
//       });

//       console.log("API Response:", response.data);

//       if (!response.data || !Array.isArray(response.data.addresses)) {
//         console.error("Invalid API response:", response.data);
//         return rejectWithValue("Invalid response from server.");
//       }

//       return response.data.addresses;
//     } catch (error) {
//       console.error("Error fetching addresses:", error);
//       return rejectWithValue(error.response?.data || "Failed to fetch addresses");
//     }
//   }
// );



// // ** Add New Address **
// export const addNewAddress = createAsyncThunk(
//   "address/addNewAddress",
//   async (addressData, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) return rejectWithValue("Authentication token missing.");

//       const response = await axios.post(`${API_BASE_URL}/add-address`, addressData, {
//         headers: { Authorization: token },
//       });

//       return response.data.address; // API should return the saved address
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Failed to add address");
//     }
//   }
// );


// // ** Update Existing Address **
// export const updateExistingAddress = createAsyncThunk(
//   "address/updateAddress",
//   async ({ id, updatedAddress }, { getState, rejectWithValue }) => {
//     try {
//       const state = getState();
//       console.log("Redux State:", state);

//       const userId = state.auth?.user?.user?.id || localStorage.getItem("user_id");
//       console.log("User ID:", userId);

//       if (!userId) {
//         console.error("User ID is missing!");
//         return rejectWithValue("User ID is required.");
//       }

//       const requestData = {
//         ...updatedAddress,
//         _id: id,
//         user_id: userId, // Ensure this is being sent
//       };

//       console.log("Sending request with data:", requestData);

//       const response = await axios.put(
//         `${API_BASE_URL}/update-address/${id}`,
//         requestData,
//         { headers: { Authorization: getAuthToken() } }
//       );

//       console.log("Response:", response.data);
//       return response.data;
//     } catch (error) {
//       console.error("Update Address Error:", error.response?.data);
//       return rejectWithValue(error.response?.data || "Failed to update address");
//     }
//   }
// );



// // ** Delete Address **
// export const deleteAddress = createAsyncThunk(
//   "address/deleteAddress",
//   async (id, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) return rejectWithValue("Authentication token missing.");
//       if (!id) return rejectWithValue("Address ID is required.");

//       const response = await axios.delete(`${API_BASE_URL}/delete-address/${id}`, {
//         headers: { Authorization: token },
//       });

//       // Ensure the API returns an expected response
//       if (response.status === 200 || response.data.success) {
//         return id; // Return deleted address ID
//       } else {
//         return rejectWithValue(response.data.message || "Failed to delete address.");
//       }
//     } catch (error) {
//       console.error("Delete Address Error:", error.response?.data || error.message);
//       return rejectWithValue(error.response?.data || "Failed to delete address.");
//     }
//   }
// );

// const getLocalStorageItem = (key) => {
//   try {
//     const data = localStorage.getItem(key);
//     return data ? JSON.parse(data) : null;
//   } catch (error) {
//     console.error(`Error parsing ${key} from localStorage:`, error);
//     return null;
//   }
// };

// const initialState = {
//   shippingAddress: getLocalStorageItem("shippingAddress") || null,
//   billingAddress: getLocalStorageItem("billingAddress") || null,
//   savedAddresses: getLocalStorageItem("savedAddresses") || [], // Ensures it's always an array
//   useSameAsShipping: true,
//   loading: false,
//   error: null,
// }

// // ** Address Slice **
// const addressSlice = createSlice({
//   name: "address",
//   initialState,
//   reducers: {
//     setShippingAddress: (state, action) => {
//       state.shippingAddress = action.payload;
//       localStorage.setItem("shippingAddress", JSON.stringify(action.payload));
//     },
//     setBillingAddress: (state, action) => {
//       state.billingAddress = action.payload;
//       localStorage.setItem("billingAddress", JSON.stringify(action.payload));
//     },
//     toggleUseSameAsShipping: (state) => {
//       state.useSameAsShipping = !state.useSameAsShipping;
//     },
//     addSavedAddress: (state, action) => {
//       state.savedAddresses.push(action.payload);
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },
//     removeSavedAddress: (state, action) => {
//       state.savedAddresses = state.savedAddresses.filter(
//         (address) => address._id !== action.payload
//       );
//       localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//     },
//     removeAllAddresses: (state) => {
//       state.shippingAddress = null;
//       state.billingAddress = null;
//       state.savedAddresses = [];
//       localStorage.removeItem("shippingAddress");
//       localStorage.removeItem("billingAddress");
//       localStorage.removeItem("savedAddresses");
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAddresses.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAddresses.fulfilled, (state, action) => {
//         state.loading = false;
//         state.savedAddresses = action.payload || []; // Ensure it's an array
//         localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses)); // Fix key name
//       })
//       .addCase(fetchAddresses.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       .addCase(addNewAddress.fulfilled, (state, action) => {
//         state.savedAddresses.push(action.payload);
//         localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//       })
//       .addCase(addNewAddress.rejected, (state, action) => {
//         state.error = action.payload || "Failed to add address";
//       })
//       .addCase(updateExistingAddress.fulfilled, (state, action) => {
//         if (action.payload) {
//           state.savedAddresses = state.savedAddresses.map((address) =>
//             address._id === action.payload._id ? action.payload : address
//           );
//           localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//         } else {
//           state.error = "Unexpected response from server";
//         }
//       })
//       .addCase(updateExistingAddress.rejected, (state, action) => {
//         state.error = action.payload?.message || "Failed to update address";
//       })
//       .addCase(deleteAddress.fulfilled, (state, action) => {
//         state.savedAddresses = state.savedAddresses.filter(
//           (address) => address._id !== action.payload
//         );
//         localStorage.setItem("savedAddresses", JSON.stringify(state.savedAddresses));
//       })
//       .addCase(deleteAddress.rejected, (state, action) => {
//         state.error = action.payload || "Failed to delete address";
//       });
//   },
// });

// // ** Export Actions **
// export const {
//   setShippingAddress,
//   setBillingAddress,
//   toggleUseSameAsShipping,
//   addSavedAddress,
//   removeSavedAddress,
//   removeAllAddresses,
// } = addressSlice.actions;

// // ** Export Reducer **
// export default addressSlice.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAddressesAPI,
  addNewAddressAPI,
  updateAddressAPI,
  deleteAddressAPI,
} from "../Providers/addressProvider";

// ** Load default address from localStorage **
const getStoredDefaultAddress = () => {
  const storedAddress = localStorage.getItem("defaultAddress");
  return storedAddress ? JSON.parse(storedAddress) : null;
};

// ** Async Thunks **
export const fetchAddresses = createAsyncThunk(
  "address/fetchAddresses",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAddressesAPI();
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch addresses");
    }
  }
);

export const addNewAddress = createAsyncThunk(
  "address/addNewAddress",
  async (addressData, { getState, dispatch, rejectWithValue }) => {
    try {
      const storedDefaultAddress = getStoredDefaultAddress();

      // ✅ Check if no default address exists and store the first one in localStorage
      if (!storedDefaultAddress) {
        localStorage.setItem("defaultAddress", JSON.stringify(addressData));
        dispatch(setShippingAddress(addressData)); // Set the first address as the shipping address
        return addressData; // Return this for Redux
      } else {
        // ✅ Add all other addresses to Redux
        return await addNewAddressAPI(addressData);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Failed to add address");
    }
  }
);

export const updateExistingAddress = createAsyncThunk(
  "address/updateAddress",
  async ({ id, updatedAddress }, { getState, rejectWithValue }) => {
    try {
      const userId = getState().auth?.user?.user?.id;
      return await updateAddressAPI(id, updatedAddress, userId);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to update address");
    }
  }
);

export const deleteAddress = createAsyncThunk(
  "address/deleteAddress",
  async (id, { rejectWithValue }) => {
    try {
      return await deleteAddressAPI(id);
    } catch (error) {
      return rejectWithValue(error.message || "Failed to delete address");
    }
  }
);

// ** Initial State **
const initialState = {
  shippingAddress: getStoredDefaultAddress(), // Load default address from localStorage
  billingAddress: null,
  savedAddresses: [],
  useSameAsShipping: true,
  loading: false,
  error: null,
};

// ** Address Slice **
const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    setShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
    },
    setBillingAddress: (state, action) => {
      state.billingAddress = action.payload;
    },
    toggleUseSameAsShipping: (state) => {
      state.useSameAsShipping = !state.useSameAsShipping;
    },
    removeAllAddresses: (state) => {
      state.shippingAddress = null;
      state.billingAddress = null;
      state.savedAddresses = [];
      localStorage.removeItem("defaultAddress"); // Clear localStorage when all addresses are removed
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddresses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddresses.fulfilled, (state, action) => {
        state.loading = false;
        state.savedAddresses = action.payload || [];
      })
      .addCase(fetchAddresses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addNewAddress.fulfilled, (state, action) => {
        // ✅ If it's the first address, don't push to savedAddresses
        const storedDefaultAddress = getStoredDefaultAddress();
        if (!storedDefaultAddress) {
          state.shippingAddress = action.payload;
        } else {
          state.savedAddresses.push(action.payload);
        }
      })
      .addCase(addNewAddress.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateExistingAddress.fulfilled, (state, action) => {
        state.savedAddresses = state.savedAddresses.map((address) =>
          address._id === action.payload._id ? action.payload : address
        );
      })
      .addCase(updateExistingAddress.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.savedAddresses = state.savedAddresses.filter(
          (address) => address._id !== action.payload
        );
      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

// ** Export Actions **
export const {
  setShippingAddress,
  setBillingAddress,
  toggleUseSameAsShipping,
  removeAllAddresses,
} = addressSlice.actions;

// ** Export Reducer **
export default addressSlice.reducer;
